// extracted by mini-css-extract-plugin
export default {"zoom":"zoom-xneH9","zoomDropdown":"zoomDropdown-TfTBm","menu":"menu-Yzf8L","zoomArrow":"zoomArrow-qEWI9","zoomLabel":"zoomLabel-JZcVX","zoomLine":"zoomLine-E9odt"};